// Localization
export const currencyPrefix = '$';
export const currencyThousandSeperator = ',';
export const currencyDecimalSeperator = '.';

// e.g. 9/3/10
export const shortDate = 'M/D/YY';

// e.g. Sep 3, 2010
export const mediumDate = 'MMM D, YYYY';

// e.g. September 3, 2010
export const longDate = 'MMMM D, YYYY';

// e.g. September 2010
export const statementDate = 'MMMM YYYY';

// e.g. 2024-12-31
export const formInputDate = 'YYYY-MM-DD';

// Months
export const monthNames: string[] = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
